<template>
  <au-layout class="material-code" title="物料二维码">
    <template slot="main">
      <qrcode-list :list="weight_list" :unit="unit"></qrcode-list>
    </template>
    <template slot="aside">
      <div class="operate-area">
        <span></span>
        <div>
          <au-button type="primary" style="margin-right: 10px;" @click="handleQuickGenerationData">一键生成数据</au-button>
          <el-popover placement="bottom-end" title="配置复制内容" width="300" trigger="click">
            <el-form :model="temp_form">
              <el-form-item label="仓库ID" prop="id">
                <el-input v-model.trim="temp_form.id"></el-input>
              </el-form-item>
              <el-form-item label="入库类型" prop="id">
                <el-input v-model.trim="temp_form.type"></el-input>
              </el-form-item>
              <el-form-item label="单次生成二维码个数" prop="number">
                <el-input v-model.trim="temp_form.number" type="number"></el-input>
              </el-form-item>
              <el-form-item>
                <au-button type="warning" @click="temporaryUse">复制</au-button>
              </el-form-item>
            </el-form>
            <au-button slot="reference" type="warning">配置复制内容</au-button>
          </el-popover>
        </div>
      </div>
      <el-form ref="form" :model="info_form" :rules="info_form_rules" label-position="top" @submit.native.prevent>
        <el-form-item prop="firstText">
          <template slot="label">
            <div style="display: inline-flex;justify-content: space-between;">
              <span>头部文本</span>
              <au-button type="text" style="margin-left: 10px;"
                @click="info_form.firstText = generateRandomString(5, 10)">一键生成</au-button>
            </div>
          </template>
          <el-input v-model.trim="info_form.firstText"></el-input>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="SPU" prop="materialSpu">
              <el-input v-model.trim="info_form.materialSpu"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="色号" prop="materialColorCode">
              <el-input v-model.trim="info_form.materialColorCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="batchNumber">
          <template slot="label">
            <div style="display: inline-flex;justify-content: space-between;">
              <span>缸号</span>
              <au-button type="text" style="margin-left: 10px;"
                @click="info_form.batchNumber = generateRandomString(3, 7, '')">一键生成</au-button>
            </div>
          </template>
          <el-input v-model.trim="info_form.batchNumber"></el-input>
        </el-form-item>
        <el-form-item prop="weightString">
          <template slot="label">
            <div style="display: inline-flex;justify-content: space-between;">
              <span>
                <span>{{ info_form.unit }}数</span>
                <el-tooltip effect="dark" content="以逗号作为拼接符" placement="top">
                  <i class="el-icon-info" style="margin: 0 8px;"></i>
                </el-tooltip>
              </span>
              <au-button type="text" @click="generateLegalStringBySpace">以空格为分隔符生成合法字符</au-button>
            </div>
          </template>
          <el-input v-model.trim="info_form.weightString" type="textarea" :rows="6" @mouseup.native="getSelectText"
            @mousedown.native="setHoverBox"></el-input>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="14">
            <el-form-item label="需要减去的皮重" prop="extraWeight">
              <el-input v-model.trim="info_form.extraWeight" type="number">
                <template slot="append">{{ unit }}</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="单位" prop="unit">
              <el-select v-model.trim="info_form.unit">
                <el-option label="公斤" value="公斤"></el-option>
                <el-option label="米" value="米"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>汇总</el-divider>
        <el-table :data="tableData" border style="margin-bottom: 10px;"
          :header-cell-style="{ background: '#cfd2d9', color: '#333', padding: '4px 0' }">
          <el-table-column label="条数" prop="total" width="60" align="center"></el-table-column>
          <el-table-column label="原始" prop="totalWeight" align="center"></el-table-column>
          <el-table-column label="皮重" prop="extraWeight" width="60" align="center"></el-table-column>
          <el-table-column label="实际" prop="realTotalWeight" align="center"></el-table-column>
        </el-table>
        <el-form-item style="text-align: right;">
          <au-button type="warning" @click="generateRandomWeightString">生成随机{{ info_form.unit }}数</au-button>
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              <div style="margin-bottom: 4px;">生成格式：文本^SPU^色号^缸号^布号^{{ info_form.unit }}</div>
              <div>如上所示，应有5个 ^ 连接6个文本内容，且{{ info_form.unit }}不能为0</div>
            </div>
            <au-button type="primary" @click="handleCheckInfoForm">生成二维码</au-button>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <div ref="hoverBox" class="hover-box" :class="{ 'active': hover_box.content !== '' }"
        :style="`top: ${hover_box.top}px;left: ${hover_box.left}px;`">
        {{ hover_box.content }}
      </div>
    </template>
  </au-layout>
</template>

<script>
/**
 * @description 物料二维码
 * @created 2024/04/19 18:36:43
 */
// 常量
import { REGEX_NUMBER } from "@/constants/regex"
import { CUSTOM_SPU, CUSTOM_COLOR_CODE, CUSTOM_PAPER_TUBE_WEIGHT, CUSTOM_PACKAGE_WEIGHT } from "@/constants/custom"
// 工具
import copy from "@/utils/clipboard"
import { randomString, randomNumberArray } from "@/utils/random"
// 组件
import QrcodeList from "./components/QrcodeList"
export default {
  meta: {
    title: "物料二维码"
  },
  name: "MaterialCode",
  components: { QrcodeList },
  data() {
    return {
      temp_form: {
        id: "1759626376299806720",
        type: "生产入库",
        number: 1000
      },
      // -----------
      info_form: {
        firstText: "",
        materialSpu: "",
        materialColorCode: "",
        batchNumber: "",
        extraWeight: 0.3,
        weightString: "",
        unit: "公斤"
      },
      info_form_rules: {
        firstText: [{ required: true, message: "请输入头部文本！", trigger: "blur" }],
        materialSpu: [{ required: true, message: "请输入SPU！", trigger: "blur" }],
        materialColorCode: [{ required: true, message: "请输入色号！", trigger: "blur" }],
        batchNumber: [{ required: true, message: "请输入缸号！", trigger: "blur" }],
        weightString: [{ required: true, message: "请输入重量！", trigger: "blur" }]
      },
      weight_list: [],
      // ---------
      hover_box: {
        top: -999,
        left: -999,
        content: ""
      }
    }
  },
  computed: {
    total() {
      const weightList = this.info_form.weightString.split(",")
      const isAllNumber = weightList.every(item => REGEX_NUMBER.test(item))
      return isAllNumber ? weightList.length : 0
    },
    totalWeight() {
      const weightList = this.info_form.weightString.split(",")
      const totalWeight = weightList.reduce((acc, cur) => {
        const weight = cur && REGEX_NUMBER.test(cur) ? Number(cur) : 0
        return acc + weight
      }, 0)
      return totalWeight ? totalWeight.myFixed() : 0
    },
    realTotalWeight() {
      const realTotalWeight = Number(this.totalWeight) - Number(this.extraWeight)
      return realTotalWeight ? realTotalWeight.myFixed() : 0
    },
    extraWeight() {
      const weightList = this.info_form.weightString.split(",")
      const isAllNumber = weightList.every(item => REGEX_NUMBER.test(item))
      return isAllNumber ? (weightList.length * this.info_form.extraWeight).myFixed() : 0
    },
    unit() {
      return this.info_form.unit === "公斤" ? "kg" : "m"
    },
    tableData() {
      return [{
        total: this.total,
        totalWeight: `${this.totalWeight}${this.unit}`,
        extraWeight: `${this.extraWeight}${this.unit}`,
        realTotalWeight: `${this.realTotalWeight}${this.unit}`
      }]
    }
  },
  methods: {
    setHoverBox() {
      this.hover_box = {
        top: -999,
        left: -999,
        content: ""
      }
    },
    getSelectText(e) {
      const selectWeightString = window.getSelection().toString()
      this.setHoverBox()
      if (!selectWeightString) return
      const weightList = selectWeightString.split(",")
      let total = 0
      const totalWeight = weightList.reduce((acc, cur) => {
        const weight = REGEX_NUMBER.test(cur) ? Number(cur) : 0
        if (weight) total++
        return acc + weight
      }, 0)
      this.hover_box.content = `总重量为：${totalWeight.myFixed()}kg，总数量为：${total}条`

      this.$nextTick(() => {
        const hoverBoxWidth = this.$refs.hoverBox.clientWidth
        const xAxisOffset = -(hoverBoxWidth / 2) // x轴偏移量
        const yAxisOffset = 50 // y轴偏移量
        this.hover_box.left = e.clientX + xAxisOffset // 获取鼠标相对于窗口左侧的横向位置
        this.hover_box.top = e.clientY - yAxisOffset // 获取鼠标相对于窗口顶部的纵向位置
      })
    },
    // 生成合法字符
    generateLegalStringBySpace() {
      this.info_form.weightString = this.info_form.weightString.trim().split(/\s+/).join(",")
    },
    // 生成随机字符串 - 用于缸号、头部文本
    generateRandomString(letterLength, numberLength, connector = "*") {
      return randomString(letterLength, numberLength, connector)
    },
    // 生成随机重量字符串
    generateRandomWeightString() {
      // 指定随机范围
      const min = this.info_form.unit === "公斤" ? 24 : 90
      const max = this.info_form.unit === "公斤" ? 26 : 99
      // 赋值
      const { number } = this.temp_form
      this.info_form.weightString = randomNumberArray(min, max, number).join(",")
    },
    // 生成重量列表
    async generateWeightList() {
      const { weightString, extraWeight, unit } = this.info_form
      const originWeightList = weightString.split(",")
      for (let i = 0; i < originWeightList.length; i++) {
        const item = originWeightList[i]
        if (!REGEX_NUMBER.test(item)) {
          this.$message.error(`请按照正确的规则输入${unit}数！`)
          return
        }
        if (Number(item) - Number(extraWeight) < 0) {
          this.$message.error(`生成后的${unit}数小于0，请检查！`)
          return
        }
      }
      // 开始渲染
      this.weight_list = []
      const qrcodeList = []
      const { firstText, materialSpu, materialColorCode, batchNumber } = this.info_form
      for (let i = 1; i <= originWeightList.length; i++) {
        const weight = (Number(originWeightList[i - 1]) - Number(extraWeight)).myFixed()
        const clothNumber = i < 10 ? `00${i}` : i < 100 ? `0${i}` : `${i}`
        qrcodeList.push({
          title: weight,
          content: `${firstText}^${materialSpu}^${materialColorCode}^${batchNumber}^${clothNumber}^${weight}`,
          qrcode: "",
          isActive: false
        })
      }
      this.weight_list = qrcodeList
      this.$message.success(`生成成功！`)
    },
    handleCheckInfoForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.generateWeightList()
        } else {
          return false
        }
      })
    },
    handleQuickGenerationData() {
      this.info_form.firstText = this.generateRandomString(5, 10)
      this.info_form.batchNumber = this.generateRandomString(3, 7, "")
      // 指定SKU
      const { materialSpu, materialColorCode } = this.info_form
      this.info_form.materialSpu = materialSpu || CUSTOM_SPU
      this.info_form.materialColorCode = materialColorCode || CUSTOM_COLOR_CODE

      this.generateRandomWeightString()
      this.handleCheckInfoForm()
    },
    temporaryUse(e) {
      const { id, type } = this.temp_form
      const obj = {
        factoryId: id,
        inboundType: type,
        outboundType: "",
        barCodeList: this.weight_list.map((item) => {
          return {
            barCode: item.content,
            materialSpu: this.info_form.materialSpu,
            materialColorCode: this.info_form.materialColorCode,
            quantity: item.title,
            paperTubeWeight: CUSTOM_PAPER_TUBE_WEIGHT,
            packageWeight: CUSTOM_PACKAGE_WEIGHT
          }
        })
      }
      copy(JSON.stringify(obj), e)
    }
  }
}
</script>

<style lang="scss" scoped>
.material-code {
  .operate-area {
    margin-bottom: 10px;
    @include flex(space-between);
  }

  ::v-deep .el-card {
    height: calc(100% - 2px);

    .el-card__body {
      padding: 0;
      height: 100%;
    }
  }

  .hover-box {
    z-index: 999;
    position: fixed;
    font-size: 12px;
    padding: 6px 8px;
    border-radius: 4px;
    pointer-events: none;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

    &.active {
      animation: fadeOut 2s ease-in-out 2s forwards;
    }
  }
}
</style>
